// API base resolution.
// Empty string = same-origin (recommended for prod; avoids Mixed Content blocks
// because the OVH proxy strips Authorization headers from cross-origin calls).
// In dev, falls back to localhost:4003.

const FROM_ENV = (process.env.REACT_APP_API_BASE ?? '').trim();

function defaultBase(): string {
  if (FROM_ENV !== '') {
    return FROM_ENV;
  }

  // Same-origin in both dev (rely on setupProxy.js to forward /api → tournament-api)
  // and prod. The historical localhost:4003 fallback no longer matches the dev
  // port (now 3200) and would break all calls when REACT_APP_API_BASE is unset.
  return '';
}

export const API_BASE = defaultBase();

export function apiUrl(path: string): string {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (API_BASE === '') {
    return path;
  }

  return `${API_BASE}${path}`;
}
